import type { DeepPartial } from "@apollo/client/utilities";

import type {
  Account,
  CreatorStat,
  TokenMetadatum,
} from "@/graphql/codegen/graphql";
import type {
  AudioMetadata,
  ImageMetadata,
  VideoMetadata,
} from "@/utils/media-utils";

export type Maybe<T> = T | null | undefined;

export type MaybeObject<T> =
  | {
      [P in keyof T]: T[P] extends object
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          T[P] extends Array<any>
          ? Maybe<Array<MaybeObject<T[P][number]>>>
          : Maybe<MaybeObject<T[P]>>
        : Maybe<T[P]>;
    }
  | null
  | undefined;

export type PartialAccount = DeepPartial<
  Omit<Account, "publicKey" | "username">
> &
  Pick<Partial<Account>, "publicKey" | "username">;

export type PostMediaMeta = Record<
  string,
  ImageMetadata | VideoMetadata | AudioMetadata
>;

export const isCreatorStatType = function (
  user: DeepPartial<CreatorStat | TokenMetadatum>,
): user is CreatorStat {
  return "desoBalanceNanos" in user;
};
